// Concrete duration helpers. ui-ux-design.md §9: "Numbers / durations are
// concrete (6m 12s, not a few minutes)".

export function formatAge(isoOrMs: string | number): string {
  const t = typeof isoOrMs === "number" ? isoOrMs : new Date(isoOrMs).getTime();
  const secs = Math.max(0, Math.floor((Date.now() - t) / 1000));
  if (secs < 60) return `${secs}s`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  return `${days}d`;
}

export function formatElapsed(sinceIsoOrMs: string | number): string {
  const t = typeof sinceIsoOrMs === "number" ? sinceIsoOrMs : new Date(sinceIsoOrMs).getTime();
  const total = Math.max(0, Math.floor((Date.now() - t) / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  if (m < 1) return `${s}s`;
  return `${m}m ${s.toString().padStart(2, "0")}s`;
}
